document.addEventListener('DOMContentLoaded', function () {

  // YYYY-MM-DD（ローカル時間）
  const getTodayStr = () => {
    const d = new Date();
    return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
  };

  const todayStr = getTodayStr();

  //カウントダウン
  const countdown = document.querySelector('.cm-header-countdown');
  if (countdown) {
    document.querySelectorAll('.header-countdown[data-target][data-tz]').forEach((el) => {
      const targetStr = (el.getAttribute('data-target') || '').trim(); // "YYYY-MM-DD HH:mm:ss"
      const tz = (el.getAttribute('data-tz') || '+09:00').trim(); // "+09:00"

      const isoLike = targetStr.replace(' ', 'T') + tz;
      const target = new Date(isoLike);

      // ===== ここが重要（不正日付チェック） =====
      const [datePart] = targetStr.split(' ');
      const [y, m, d] = (datePart || '').split('-').map(Number);

      if (
        Number.isNaN(target.getTime()) || // Dateとして不正
        target.getFullYear() !== y || // 年がズレてる
        target.getMonth() + 1 !== m || // 月がズレてる
        target.getDate() !== d // 日がズレてる（← 2/31対策）
      ) {
        el.style.display = 'none';
        console.log('カウントダウンで設定された日付が正しくありません');
        return;
      }

      const dEl = el.querySelector('[data-days]');
      const hEl = el.querySelector('[data-hours]');
      const mEl = el.querySelector('[data-minutes]');
      const sEl = el.querySelector('[data-seconds]');

      const pad2 = (n) => String(n).padStart(2, '0');

      const update = () => {
        const now = new Date();
        const diffMs = target.getTime() - now.getTime();

        if (diffMs <= 0) {
          el.style.display = 'none'; // ✅ 終了したら非表示
          //MicroModal.close('cm-popup');
          const heading = document.querySelector('.cm-header-countdown__heading');
          const finHeading = document.querySelector('.cm-header-countdown__fin-heading');
          if (finHeading && finHeading.textContent.trim() !== '') {
            finHeading.style.display = 'block';
            if (heading) heading.style.display = 'none';
          }
          clearInterval(timer);
          return;
        }

        const total = Math.floor(diffMs / 1000);
        const days = Math.floor(total / 86400);
        const hours = Math.floor((total % 86400) / 3600);
        const minutes = Math.floor((total % 3600) / 60);
        const seconds = total % 60;

        dEl.textContent = pad2(days);
        hEl.textContent = pad2(hours);
        mEl.textContent = pad2(minutes);
        sEl.textContent = pad2(seconds);
      };

      update();
      const timer = setInterval(update, 1000);
      countdown.style.visibility = 'visible';
    });
  }
});
